import * as React from "react";
import { Redirect } from "react-router-dom";

const GotoCheckMail: React.FC = () => <Redirect to="/check-mail" />;

export default GotoCheckMail;
